import styled from "styled-components";

export const HeaderContainer = styled.header`
/* height: 93px; */
	.header-container {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		width: 100%;
		
		-webkit-transition: all 0.3s ease-out 0s;
		transition: all 0.3s ease-out 0s;
		background: var(--white);
		box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);
		z-index: 200;
		padding-left: 24px;
		padding-right: 24px;
		&.sticky{
			background: var(--white);
			box-shadow: 0px 3px 5px rgba(0, 0, 0, .15);
			padding-left: 1.5rem;
			padding-right: 1.5rem;
		}
		.headerActions{
			gap: 16px;
			input[type="text"]{
				width: 600px;
			}
		}
		@media (max-width: 767px) {
			& {
				padding-left: 1rem;
				padding-right: 1rem;
				.headerActions{
					gap: 5px;
					
				}
			}
		}
	}
	.nav-bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 5px;
		padding-top: 16px;
		padding-bottom: 16px;
		max-width: 1499px;
		margin-left: auto;
		margin-right: auto;
	}
	.logo {
		width: 179px;
		cursor: pointer;
		span {
		width: 100%;
		}
		img {
		width: 179px;
		height: auto;
		-webkit-transition: all 0.3s ease-out 0s;
		transition: all 0.3s ease-out 0s;
		}
	}
	.signin-btn {
		box-shadow: 5px 0px 5.64px 5.1px #064a930d;
	}
	.toggleBtn {
		display: none;
	}
	.whtLngWrapper {
		gap: 7px;
	}
	.headerBtn {
		background-color: var(--themeColor);
	}

	.Social-links {
		display: flex;
		gap: 12px;
		cursor: pointer;
	}
	.notifyToggle{
		padding: 7px 9px;
		background-color: var(--bg);
		border: 1px solid var(--border);
		position: relative;
		&:focus{
			background-color: var(--bg);
			border: 1px solid var(--border);
		}
		.red-dot{
			height: 11px;
			width: 11px;
			border-radius: 50%;
			position: absolute;
			top: 5px;
			right: 10px;
			background-color: var(--redColor);
			border: 2px solid var(--bg);
		}
	}
	.dropNotifyListContainer{
		width: 470px;
		inset: 0px 0 auto auto;
		padding: 0;
		.dropDownHeader{
			display: flex;
			align-items: center;
			padding: 15px 24px;
			border: 1px solid var(--border);
			justify-content: space-between;
			.dropDownHeaderTitle{
				display: flex;
				align-items: center;
				gap: 28px;
				.notifyStatus{
					display: flex;
					width: fit-content;
					background-color: var(--lightGreen);
					padding: 3px 12px;
					border-radius: 8px;
				}
			}
		}
	}
	.searchToggle{
		display: none;
		border-radius: 4px;
		cursor: pointer;
		padding: 7px 9px;
		background-color: var(--bg);
		border: 1px solid var(--border);
	}
	@media (max-width: 1199px) {
		.nav-bar button span {
		font-size: 14px;
		}
		.headerActions{
		input[type="text"]{
			width: 400px !important;
		}
		}
	}
	@media (max-width: 991px) {
		.headerActions{
		input[type="text"]{
			width: 250px !important;
		}
		}
	}
	@media (max-width: 767px) {
		.searchMainH{
			display: none;
		}
		.searchToggle{
			display: block;
		}
	}
	@media (max-width: 480px) {
		.hMainName{
			display: none;
		}
	}
	
`;
